module.exports = __webpack_public_path__ + "static/media/edit.f75b5770.svg";